// 건강 상태 옵션
export const HEALTH_CONDITIONS = [
  { value: "당뇨병", label: "당뇨병" },
  { value: "고혈압", label: "고혈압" },
  { value: "심장질환", label: "심장질환" },
  { value: "관절염", label: "관절염" },
  { value: "골다공증", label: "골다공증" },
  { value: "갑상선질환", label: "갑상선질환" },
  { value: "알레르기", label: "알레르기" },
  { value: "소화기질환", label: "소화기질환" },
  { value: "호흡기질환", label: "호흡기질환" },
  { value: "통풍", label: "통풍" },
  { value: "없음", label: "없음" },
  { value: "기타", label: "기타" },
] as const;

// 식이 제한사항 옵션
export const DIETARY_RESTRICTIONS = [
  // === 질병 기반 제한사항 ===
  { value: "통풍", label: "통풍" },

  // === 알레르기 기반 제한사항 ===
  { value: "유제품알레르기", label: "유제품 알레르기" },
  { value: "밀알레르기", label: "밀 알레르기" },
  { value: "땅콩알레르기", label: "땅콩 알레르기" },
  { value: "견과류알레르기", label: "견과류 알레르기" },
  { value: "해산물알레르기", label: "해산물 알레르기" },
  { value: "갑각류알레르기", label: "갑각류 알레르기" },
  { value: "연체류알레르기", label: "연체류 알레르기" },
  { value: "난류알레르기", label: "난류 알레르기" },
  { value: "대두알레르기", label: "대두 알레르기" },
  { value: "참깨알레르기", label: "참깨 알레르기" },
  { value: "유당불내증", label: "유당 불내증" },
  { value: "글루텐불내증", label: "글루텐 불내증" },

  // === 식습관 기반 제한사항 ===
  { value: "채식주의", label: "채식주의" },

  // === 영양 성분 기반 제한사항 (현재 지원) ===
  { value: "저탄수화물", label: "저탄수화물" },
  { value: "저지방", label: "저지방" },
  { value: "저염", label: "저염" },
  { value: "저당", label: "저당" },
  { value: "고항산화", label: "고항산화" },

  { value: "기타", label: "기타" },
  { value: "없음", label: "없음" },
] as const;

// 타입 정의
export type HealthCondition = (typeof HEALTH_CONDITIONS)[number]["value"];
export type DietaryRestriction = (typeof DIETARY_RESTRICTIONS)[number]["value"];

// 레시피 난이도 옵션
export const DIFFICULTY_OPTIONS = [
  { value: "easy", label: "쉬움" },
  { value: "medium", label: "보통" },
  { value: "hard", label: "어려움" },
] as const;

export type DifficultyLevel = (typeof DIFFICULTY_OPTIONS)[number]["value"];

// 효능 카테고리 (건강 관련)
export const HEALTH_CATEGORIES = [
  "항산화",
  "항염",
  "면역력",
  "뇌건강",
  "심혈관",
] as const;

// 종류 카테고리 (요리 타입)
export const TYPE_CATEGORIES = [
  "전채",
  "파스타",
  "샐러드",
  "메인",
  "스프",
  "디저트",
  "음료",
  "스낵",
] as const;

// 스타일 카테고리 (국가/스타일)
export const STYLE_CATEGORIES = [
  "한국",
  "일본",
  "아시안",
  "이탈리아",
  "프랑스",
  "지중해",
  "비건",
  "해산물",
  "여름요리",
  "브런치",
] as const;

// 알레르기 성분 카테고리별 그룹화
export const ALLERGEN_GROUPS = {
  글루텐: [
    "글루텐",
    "밀",
    "호밀",
    "보리",
    "밀가루",
    "빵",
    "쿠키",
    "케이크",
    "파스타",
  ],
  유제품: ["유제품", "우유", "치즈", "버터", "요거트", "크림"],
  난류: ["난류", "계란", "메추리알", "마요네즈"],
  견과류: [
    "견과류",
    "아몬드",
    "호두",
    "피칸",
    "마카다미아",
    "피스타치오",
    "캐슈넛",
    "잣",
  ],
  땅콩: ["땅콩", "땅콩버터"],
  해산물: [
    "해산물",
    "생선",
    "갑각류",
    "새우",
    "게",
    "랍스터",
    "패류",
    "두족류",
    "조개",
    "굴",
    "소라",
    "전복",
    "문어",
    "오징어",
    "쭈꾸미",
    "해삼",
  ],
  대두: ["대두", "콩", "두부", "된장", "간장", "두유"],
  참깨: ["깨류", "참깨", "참기름", "타히니"],
  육류: ["육류", "소고기", "돼지고기", "닭고기", "양고기", "오리고기"],
  기타: ["알코올", "꿀", "카페인", "퓨린"],
} as const;

// 모든 알레르기 성분을 하나의 배열로
export const ALLERGEN_OPTIONS = Object.values(ALLERGEN_GROUPS).flat();

// 레시피 카테고리 타입 정의
export type HealthCategory = (typeof HEALTH_CATEGORIES)[number];
export type TypeCategory = (typeof TYPE_CATEGORIES)[number];
export type StyleCategory = (typeof STYLE_CATEGORIES)[number];
export type AllergenGroup = keyof typeof ALLERGEN_GROUPS;
export type AllergenOption = (typeof ALLERGEN_OPTIONS)[number];
